// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import A7f3c2e8d9b1Controller from "./a7f3c2e8d9b1_controller"
application.register("a7f3c2e8d9b1", A7f3c2e8d9b1Controller)

import AdminSearchController from "./admin_search_controller"
application.register("admin-search", AdminSearchController)

import AccountAddressSelectorController from "./account_address_selector_controller"
application.register("account-address-selector", AccountAddressSelectorController)

import AccountTabsController from "./account_tabs_controller"
application.register("account-tabs", AccountTabsController)

import AddressSelectorController from "./address_selector_controller"
application.register("address-selector", AddressSelectorController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import CheckallController from "./checkall_controller"
application.register("checkall", CheckallController)

import CountrySelectController from "./country_select_controller"
application.register("country-select", CountrySelectController)

import Decode64Controller from "./decode64_controller"
application.register("decode64", Decode64Controller)

import EmailObfuscateController from "./email_obfuscate_controller"
application.register("email-obfuscate", EmailObfuscateController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmailPreviewController from "./email_preview_controller"
application.register("email-preview", EmailPreviewController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageSwitcherController from "./image_switcher_controller"
application.register("image-switcher", ImageSwitcherController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModelviewController from "./modelview_controller"
application.register("modelview", ModelviewController)

import PaymentPollController from "./payment_poll_controller"
application.register("payment-poll", PaymentPollController)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TrackingAutofillController from "./tracking_autofill_controller"
application.register("tracking-autofill", TrackingAutofillController)

import ContactSelectController from "./contact_select_controller"
application.register("contact-select", ContactSelectController)

import LineItemsController from "./line_items_controller"
application.register("line-items", LineItemsController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import ProfilePreviewController from "./profile_preview_controller"
application.register("profile-preview", ProfilePreviewController)
